import React from 'react';

import styled from 'styled-components';

import Button from '@adsk/alloy-react-button';
import { MagnifyingGlassIcon, XCircleFilledIcon } from '@adsk/alloy-react-icon';
import theme from '@adsk/alloy-react-theme';

export const StyledPackagesSearchFilterButton = styled.div`
  display: flex;
  align-items: center;
  border: 1px solid ${theme.colors.charcoal400};
  border-radius: 2px;
`;

export const StyledSearchFilterButton = styled(Button).attrs({
  renderIcon: (props) => <MagnifyingGlassIcon {...props} />,
})`
  border: none;
  border-radius: 0;
  white-space: nowrap;
`;

export const StyledClearSearchFilterButton = styled(Button).attrs({
  renderIcon: (props) => <XCircleFilledIcon {...props} />,
})`
  border: none;
  border-radius: 0;
  border-left: 1px solid ${theme.colors.charcoal400};
`;
